import { useEffect } from 'react';
import { useTeamStore } from '../../../stores/teamStore';
import { usePilgrimGuideStore } from '../../../stores/pilgrimGuideStore';
import { usePackagesStore } from '../../../stores/packagesStore';
import { useFlightsStore } from '../../../stores/flightsStore';
import { useAccommodationStore } from '../../../stores/accommodationStore';
import { useDisputesStore } from '../../../stores/disputesStore';

export const useDashboardData = (isAdmin: boolean = false) => {
  const userId = localStorage.getItem('userId');
  
  // Initialize stores
  const { fetchUsers, fetchRoles } = useTeamStore();
  const { fetchLinks } = usePilgrimGuideStore();
  const { fetchPackages } = usePackagesStore();
  const { fetchFlights } = useFlightsStore();
  const { fetchTables } = useAccommodationStore();
  const { fetchDisputes } = useDisputesStore();

  useEffect(() => {
    const initializeData = async () => {
      if (isAdmin) {
        // Admin data initialization
        await Promise.all([
          fetchUsers(),
          fetchRoles(),
          fetchLinks(),
          fetchPackages(),
          fetchFlights(),
          fetchTables(),
          fetchDisputes()
        ]);
      } else if (userId) {
        // Guide data initialization
        await fetchLinks(userId);
      }
    };

    initializeData();
  }, [
    isAdmin, 
    userId, 
    fetchUsers, 
    fetchRoles, 
    fetchLinks, 
    fetchPackages,
    fetchFlights,
    fetchTables,
    fetchDisputes
  ]);
};